import { jsx as _jsx } from "react/jsx-runtime";
import { getUrl } from '@web/router/getUrl';
import { dashboardUrl, installationUrl, settingsUrl, signInUrl } from '@web/router/urls';
import { settingsActiveTabs } from '@web/utility/tabs';
import { UserRole } from '@workalizer/db';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
export var PostInstallRoute = function (_a) {
    var user = _a.user, children = _a.children;
    if (!(user === null || user === void 0 ? void 0 : user.workspace)) {
        return children;
    }
    if (user.isAdmin && user.workspace.googleIntegrationNeedsReauth) {
        return children;
    }
    return _jsx(Navigate, { to: dashboardUrl, replace: true });
};
export var InstalledAppRequiredRoute = function (_a) {
    var _b;
    var user = _a.user, children = _a.children;
    var location = useLocation();
    if (!user)
        return _jsx(Navigate, { to: signInUrl });
    if (!(user === null || user === void 0 ? void 0 : user.workspace))
        return _jsx(Navigate, { to: installationUrl });
    // Check if subscription is expired
    var subscription = (_b = user.workspace) === null || _b === void 0 ? void 0 : _b.subscription;
    if (subscription === null || subscription === void 0 ? void 0 : subscription.expiryDate) {
        var expiryDate = new Date(subscription.expiryDate);
        var now = new Date();
        var isExpired = expiryDate < now && !subscription.isCanceled;
        if (isExpired) {
            var billingUrl = getUrl(settingsUrl, settingsActiveTabs.billing);
            var isOnBillingPage = location.pathname === billingUrl;
            // If user is admin and not already on billing page, redirect to billing page
            if (user.role === UserRole.ADMIN && !isOnBillingPage) {
                return _jsx(Navigate, { to: billingUrl, replace: true });
            }
            // For non-admin users, show access denied or redirect to sign in
            if (user.role !== UserRole.ADMIN) {
                return _jsx(Navigate, { to: signInUrl, replace: true });
            }
        }
    }
    return children;
};
export var AuthorizationRequiredRoute = function (_a) {
    var user = _a.user, children = _a.children;
    if (!user)
        return _jsx(Navigate, { to: signInUrl });
    return children;
};
export var NoAutharizationRoute = function (_a) {
    var user = _a.user, children = _a.children;
    if (user)
        return _jsx(Navigate, { to: dashboardUrl });
    return children;
};
